import './index.css';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { View, Text } from '../../../component';
import { isMobileBrowser } from '../../../utilities/helper';
import Button from '@mui/material/Button/Button';
import React from 'react';

interface Props {
  visible: boolean;
  onPressClose: any;
  onPressDelete: any;
}
const SubstituteOperationModal = ({ visible, onPressClose, onPressDelete }: Props) => {
  const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  const className = `${bottomSheetWidth}`;
  return (
    <BottomSheet className={className} onDismiss={onPressClose} open={visible}>
      <View className={'substitute-operation-modal-container'}>
        <View className={'substitute-operation-modal-sub-container'}>
          <Text className={'substitute-operation-modal-title'}>
            {"Do you want to delete this player's substitution"}
          </Text>
          <View className={'substitute-operation-modal-bottom-container'}>
            <Button className={'substitute-operation-modal-button'} onClick={onPressClose}>
              {'Cancel'}
            </Button>
            <Button className={'substitute-operation-modal-button'} onClick={onPressDelete}>
              {'Delete'}
            </Button>
          </View>
        </View>
      </View>
    </BottomSheet>
  );
};
export default React.memo(SubstituteOperationModal);
